// removed by extract-text-webpack-plugin
module.exports = {"BrandingLink":"BrandingLink---2Tm6g","BrandingLink--black":"BrandingLink--black---2Dyi3"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Customize/Styling/DriftBranding/style.styl
// module id = YwUe
// module chunks = 89